module.exports = __webpack_public_path__ + "img/smc.21548e22.jpg";